<section id="servizi" class="services-area pt-400 pb-150 section-bg section-padding30">
  <section class="wantToWork-area w-padding">
    <div class="container">
      <div class="row align-items-end justify-content-between">
        <div class="col-lg-6 col-md-10 col-sm-10">
          <div class="section-title section-title2">
            <h1>Servizi</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-6">
        <div class="single-cat text-center mb-50">
          <div class="cat-icon">
            <i class="flaticon-fitness"></i>
          </div>
          <div class="cat-cap">
            <!-- <h3><a [routerLink]="['/sala-pesi']">SALA PESI</a></h3> -->
            <h3>SALA PESI</h3>
          </div>
          <!--           <div class="img-cap">
            <a [routerLink]="['/sala-pesi']">Scopri di più <i class="ti-arrow-right"></i></a>
          </div> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-6">
        <div class="single-cat text-center mb-50">
          <div class="cat-icon">
            <i class="flaticon-healthcare-and-medical"></i>
          </div>
          <div class="cat-cap">
            <!--             <h3><a [routerLink]="['/pt']">PERSONAL TRAINING</a></h3> -->
            <h3>PERSONAL TRAINING</h3>
          </div>
          <!--           <div class="img-cap">
            <a [routerLink]="['/pt']">Scopri di più <i class="ti-arrow-right"></i></a>
          </div> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-6">
        <div class="single-cat text-center mb-50">
          <div class="cat-icon">
            <i class="flaticon-healthcare-and-medical"></i>
          </div>
          <div class="cat-cap">
            <h3><a [routerLink]="['/corsi']">CORSI</a></h3>
          </div>
          <div class="img-cap">
            <a [routerLink]="['/corsi']">Scopri di più <i class="ti-arrow-right"></i></a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-6">
        <div class="single-cat text-center mb-50">
          <div class="cat-icon">
            <i class="flaticon-healthcare-and-medical"></i>
          </div>
          <div class="cat-cap">
            <h3><a href="https://www.instagram.com/fullmuscle.nutrition?igsh=ZDNlZDc0MzIxNw=="> INTEGRATORI
                ALIMENTARI</a></h3>
          </div>
          <div class="img-cap">
            <!--             <a [routerLink]="['/integratori']">Scopri di più <i class="ti-arrow-right"></i></a> -->
            <a href="https://www.instagram.com/fullmuscle.nutrition?igsh=ZDNlZDc0MzIxNw==">Scopri di più <i
                class="ti-arrow-right"></i></a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-6">
        <div class="single-cat text-center mb-50">
          <div class="cat-icon">
            <i class="flaticon-clock"></i>
          </div>
          <div class="cat-cap">
            <!-- <h3><a [routerLink]="['/fisioterapista']">FISIOTERAPISTA / OSTEOPATA</a></h3> -->
            <h3>FISIOTERAPISTA / OSTEOPATA</h3>
          </div>
          <!--           <div class="img-cap">
            <a [routerLink]="['/fisioterapista']">Scopri di più <i class="ti-arrow-right"></i></a>
          </div> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-6">
        <div class="single-cat text-center mb-50">
          <div class="cat-icon">
            <i class="flaticon-clock"></i>
          </div>
          <div class="cat-cap">
            <!-- <h3><a [routerLink]="['/nutrizionista']">NUTRIZIONISTA</a></h3> -->
            <h3>NUTRIZIONISTA</h3>
          </div>
          <!--           <div class="img-cap">
            <a [routerLink]="['/nutrizionista']">Scopri di più <i class="ti-arrow-right"></i></a>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</section>